import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { getApiUrl, API_URL } from '@/utils/api';
import ApiBase from './ApiBase';

export default class BentoService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/bento');

  getBentoByStoreId(storeId: string) {
    const searchParams = new URLSearchParams({ storeId });

    return this.api.getJSON(`${BentoService.baseUrl}/byStoreId?${searchParams.toString()}`).pipe(
      catchError(() => of({}))
    );
  }
}
